import { Link, useLocation } from "react-router-dom";

export interface SideMenuItem {
  title: string;
  icon: React.ReactNode;
  link: string;
}

const SideMenu = ({ items }: { items: SideMenuItem[] }) => {
  const location = useLocation();

  return (
    <div className="min-w-48 bg-slate-100 p-2 flex flex-col gap-1 border-solid border">
      {items.map((item) => {
        // Parse the item link to get path and search params
        let itemPath = item.link;
        let itemSearchParams = "";

        if (item.link.includes("?")) {
          const [path, search] = item.link.split("?");
          itemPath = path;
          itemSearchParams = search;
        }

        // Check if the current path matches
        const pathMatches =
          location.pathname === itemPath || (itemPath !== "/" && location.pathname.startsWith(itemPath));

        // Check if search params match when present
        let searchParamsMatch = true;
        if (itemSearchParams) {
          // If the item has search params, they must be present in the current URL
          searchParamsMatch = location.search.substring(1).includes(itemSearchParams);
        }

        const isActive = pathMatches && searchParamsMatch;

        return (
          <Link
            to={item.link}
            key={item.title}
            className={`flex items-center gap-2 p-2 text-[15px] rounded-md hover:bg-primary/20 w-full ${
              isActive ? "bg-primary/10 text-primary font-semibold" : ""
            }`}
          >
            {item.icon}
            <span>{item.title}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default SideMenu;
